import React, { useEffect } from 'react';
import styles from './styles.module.css';

const Adbox = () => {
    useEffect(() => {
        const scriptId = 'adsbygoogle-script';
        let script = document.getElementById(scriptId);

        const pushAd = () => {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) {
                console.error('Adsbygoogle error:', e);
            }
        };

        if (!script) {
            script = document.createElement('script');
            script.id = scriptId;
            script.async = true;
            script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7061075886842339';
            script.crossOrigin = 'anonymous';
            script.onload = () => {
                pushAd();
            };
            document.head.appendChild(script);
        } else {
            pushAd();
        }
    }, []);

    return (
        <div className={styles.adboxContainer}>
            {/* sanoft-pos-admin-bottom */}
            <ins
                className="adsbygoogle"
                style={{ display: 'block', width: '100%', height: '100%' }}
                data-ad-client="ca-pub-7061075886842339"
                data-ad-slot="6306344812"
                data-ad-format="auto"
                data-full-width-responsive="true"
            ></ins>
        </div>
    );
};

export default Adbox;
